export async function apiJson<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      "content-type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
  const payload = await parseJsonResponse(response);
  if (!response.ok) {
    throw new Error(payload.error ?? "تعذر تنفيذ الطلب.");
  }
  return payload as T;
}

export async function parseJsonResponse(response: Response): Promise<Record<string, unknown> & { error?: string }> {
  const contentType = response.headers.get("content-type") ?? "";
  if (!contentType.includes("application/json")) {
    return {
      error:
        response.ok
          ? "واجهة API غير متاحة من خادم Vite المحلي. استخدم npm run pages:dev لاختبار Cloudflare Pages Functions."
          : "تعذر قراءة استجابة الخادم.",
    };
  }

  return (await response.json().catch(() => ({
    error: "تعذر قراءة استجابة الخادم.",
  }))) as Record<string, unknown> & { error?: string };
}
